import classNames from 'classnames/bind';
import { useEffect, useRef } from 'react';
import { setMapInitialView } from 'everywhere/common/map/map';
import {
  addMarkers,
  handleOverlappedMarkers,
  removeMarkers,
  setMarkersSize,
} from 'everywhere/common/map/marker';
import { IItem, IMarker } from 'everywhere/common/map/types';
import { getNaverMaps } from 'everywhere/common/map/utils';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProp {
  list: IItem[];
}

export default function Map({ list }: IProp) {
  const mapRef = useRef<naver.maps.Map>();
  const departureMarkersRef = useRef<IMarker[]>([]);
  const destinationMarkersRef = useRef<IMarker[]>([]);

  useEffect(() => {
    const naverMaps = getNaverMaps();
    const min: naver.maps.LatLng = new naverMaps.LatLng(-85, -180);
    const max: naver.maps.LatLng = new naverMaps.LatLng(85, 180);
    const bounds = new naverMaps.LatLngBounds(min, max);
    const mapOptions: naver.maps.MapOptions = {
      zoom: 2,
      minZoom: 2,
      bounds,
      mapTypes: new naverMaps.MapTypeRegistry({
        normal: naverMaps.NaverStyleMapTypeOptions.getNormalMap({
          repeatX: true,
        }),
      }),
      background: '#A5D1F2',
      tileSpare: 2,
      tileTransition: false,
    };
    mapRef.current = new naverMaps.Map('map', mapOptions);
    return () => {
      if (mapRef.current) mapRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    addMarkers({ departureMarkersRef, destinationMarkersRef, mapRef, list });
    setMarkersSize(destinationMarkersRef.current);
    handleOverlappedMarkers(destinationMarkersRef.current);
    setMapInitialView({
      map: mapRef.current,
      markers: destinationMarkersRef.current,
    });
    return () => {
      removeMarkers({ departureMarkersRef, destinationMarkersRef });
    };
  }, [list]);

  return (
    <div className={cx('Map')}>
      <div id="map" className={cx('content')}/>
    </div>
  );
}
